import { Injectable } from '@angular/core';
import { Boleto } from '../models/Boleto';
import { environment } from '../../environments/environment';
import { MetodosLigaColaborador } from './metodos-liga-colaborador';
import { ModoLigaApp } from './modo-liga-app';

@Injectable()
export class LocalstorageService {
  setBoletosGenerados(boletos_generados: Array<Object>) {
    sessionStorage.setItem('BoletosGenerados', JSON.stringify(boletos_generados));
  }

  getBoletosGenerados() {
    return sessionStorage.getItem('BoletosGenerados');
  }

  deleteBoletosGenerados() {
    sessionStorage.removeItem('BoletosGenerados');
  }

  getBoletosRecomendados() {
    return sessionStorage.getItem('BoletosRecomendados');
  }

  setBoletosRecomendados(boletos_recomendados: Array<Boleto>) {
    sessionStorage.setItem('BoletosRecomendados', JSON.stringify(boletos_recomendados));
  }

  getBoletosAsignados() {
    return sessionStorage.getItem('BoletosAsignados');
  }

  deleteBoletosAsignados() {
    sessionStorage.removeItem('BoletosAsignados');
  }

  setBoletosAsignados(boletos_asignados: Array<Boleto>) {
    sessionStorage.setItem('BoletosAsignados', JSON.stringify(boletos_asignados));
  }

  getBoletosApartados() {
    return sessionStorage.getItem('BoletosApartados');
  }

  setBoletosApartados(boletos_apartados: Array<Boleto>) {
    sessionStorage.setItem('BoletosApartados', JSON.stringify(boletos_apartados));
  }

  deleteBoletosApartados() {
    sessionStorage.removeItem('BoletosApartados');
  }

  setArrayLogin(login: Array<Object>) {
    localStorage.setItem('Login', JSON.stringify(login));
  }

  getArrayLogin() {
    return localStorage.getItem('Login');
  }

  deleteArrayLogin() {
    localStorage.removeItem('Login');
  }

  deleteBoletosRecomendados() {
    sessionStorage.removeItem('BoletosRecomendados');
  }

  setFechaInicio(date: Date) {
    localStorage.setItem('FechaInicio', date.toString());
  }

  getFechaInicio() {
    return localStorage.getItem('FechaInicio');
  }

  deleteFechaInicio() {
    localStorage.removeItem('FechaInicio');
  }

  setFechaFin(date: Date, minutos?: number) {
    date.setMinutes(date.getMinutes() + (minutos !== undefined ? minutos : environment.timerMinutos));
    localStorage.setItem('FechaFin', date.toString());
  }

  getFechaFin() {
    return localStorage.getItem('FechaFin');
  }

  deleteFechaFin() {
    localStorage.removeItem('FechaFin');
  }

  setFolio(folio: string) {
    localStorage.setItem('Folio', folio);
  }

  getFolio() {
    return localStorage.getItem('Folio');
  }

  deleteFolio() {
    localStorage.removeItem('Folio');
  }
  setPKColab(pkcolab: string) {
    localStorage.setItem('pkcolab', pkcolab);
  }
  getPKColab() {
    return localStorage.getItem('pkcolab');
  }
  removePKColab() {
    localStorage.removeItem('pkcolab');
  }
  setMecanismoColabExt(Mecanismo: string) {
    localStorage.setItem('MecanismoColab', Mecanismo);
  }
  getMecanismoColabExt() {
    return localStorage.getItem('MecanismoColab');
  }
  removeMecanismoColabExt() {
    localStorage.removeItem('MecanismoColab');
  }

  setBoletosBloqueados(boletos_bloqueados: Array<Object>) {
    sessionStorage.setItem('BoletosBloqueados', JSON.stringify(boletos_bloqueados));
  }

  getBoletosBloqueados() {
    return sessionStorage.getItem('BoletosBloqueados');
  }

  deleteBoletosBloqueados() {
    sessionStorage.removeItem('BoletosBloqueados');
  }
  setCarrito(idcarrito: string) {
    sessionStorage.setItem('idcarrito', idcarrito);
  }

  getCarrito() {
    return sessionStorage.getItem('idcarrito');
  }

  deleteCarrito() {
    sessionStorage.removeItem('idcarrito');
  }

  setPaybackref(compradorPayback: number) {
    localStorage.setItem('Paybackref', compradorPayback.toString());
  }
  getPaybackref() {
    return localStorage.getItem('Paybackref');
  }
  deletePaybackref() {
    localStorage.removeItem('Paybackref');
  }
/** Cambios Luis Aguilar WECODE */
  setCampaingnData(campaingData: any) {
    localStorage.setItem('campaingData', JSON.stringify(campaingData));
  }
  getCampaingnData() {
    return JSON.parse(localStorage.getItem('campaingData'));
  }
  deleteCampaingnData() {
    localStorage.removeItem('campaingData');
  }
  /** END Cambios Luis Aguilar WECODE */

  /**
   * Limpia el estado de LA COMPRA (boletos, folio, carrito) pero CONSERVA a quien esta
   * apoyando el comprador: las llaves de la liga de colaborador.
   *
   * POR QUE EXISTE: los sessionStorage.clear() eran de escoba y se llevaban tambien
   * 'liga_compartida_colaborador' y 'liga_compartida_nombre_colaborador'. Esas dos NO son
   * de la compra: son "a quien estoy apoyando". Al borrarlas, despues de un error de pago
   * o de una venta exitosa el comprador se quedaba sin el camino de vuelta a los boletos
   * de su colaborador — que todavia tiene mas por vender.
   *
   * Sigue viviendo en sessionStorage a proposito: asi muere al cerrar el navegador.
   * El unico que las borra deliberadamente es "cancelar apoyo" en el footer.
   */
  limpiarCompra() {
    const liga   = sessionStorage.getItem('liga_compartida_colaborador');
    const nombre = sessionStorage.getItem('liga_compartida_nombre_colaborador');
    // El modo liga App tambien sobrevive: si se borrara aqui, al terminar/cancelar el
    // usuario quedaria libre para irse al home (ver ModoLigaApp).
    const modoLigaApp = ModoLigaApp.respaldar();
    // Los folios que pasaron por la liga tambien: si vuelven a pagarse en esta pestaña,
    // siguen sin MIT (ver MetodosLigaColaborador).
    const foliosLiga = MetodosLigaColaborador.respaldar();

    sessionStorage.clear();

    if (liga)   sessionStorage.setItem('liga_compartida_colaborador', liga);
    if (nombre) sessionStorage.setItem('liga_compartida_nombre_colaborador', nombre);
    ModoLigaApp.restaurar(modoLigaApp);
    MetodosLigaColaborador.restaurar(foliosLiga);
  }

  /** La liga de colaborador que se esta apoyando, o null. */
  getLigaColaborador() {
    return sessionStorage.getItem('liga_compartida_colaborador');
  }

  getNombreColaboradorLiga() {
    return sessionStorage.getItem('liga_compartida_nombre_colaborador');
  }
}
